import React from 'react';
import { CircularProgress, Menu, MenuItem, Tooltip } from '@mui/material';
import { Sync, LinkOff } from '@mui/icons-material';

import './CalendarListMoreDropdown.scss';
import { CalendarListMoreDropdownOption } from './types';
import { useTranslation } from 'react-i18next';

interface CalendarListMoreDropdownProps {
  anchorEl: HTMLElement | null;
  loadingOption?: CalendarListMoreDropdownOption;
  canDelete?: boolean;
  onClickItem: (option: CalendarListMoreDropdownOption) => void;
  onClose: () => void;
}

const CalendarListMoreDropdown: React.FC<CalendarListMoreDropdownProps> = ({
  anchorEl,
  loadingOption,
  canDelete = true,
  onClickItem,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <Menu
      className="calendar-list-more-dropdown"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <MenuItem
        disabled={!!loadingOption}
        onClick={() => onClickItem('sync')}
        className="calendar-list-more-dropdown__option"
      >
        {loadingOption === 'sync' && <CircularProgress size={15} />}
        {loadingOption !== 'sync' && (
          <>
            <Sync fontSize="small" />
            <p className="calendar-list-more-dropdown__option__title">
              {t('calendar.sidebar.syncCalendars')}
            </p>
          </>
        )}
      </MenuItem>
      <Tooltip title={canDelete ? '' : t('calendar.sidebar.mainAccountCannotBeRemoved')}>
        <div>
          {/* Need to wrap by div to show the tooltip */}
          <MenuItem
            disabled={!canDelete || !!loadingOption}
            onClick={() => onClickItem('delete')}
            className="calendar-list-more-dropdown__option"
          >
            {loadingOption === 'delete' && <CircularProgress size={15} />}
            {loadingOption !== 'delete' && (
              <>
                <LinkOff fontSize="small" />
                <p className="calendar-list-more-dropdown__option__title">
                  {t('calendar.sidebar.disconnectCalendars')}
                </p>
              </>
            )}
          </MenuItem>
        </div>
      </Tooltip>
    </Menu>
  );
};

export default CalendarListMoreDropdown;
